import React, { Component } from "react";
import Title from "../GenericComponents/Title";
import swal from "sweetalert";
import { post_ApiManager, get_ApiManager } from "../ApiManager/ApiManager";
import { useNavigate } from "react-router-dom";
import { countries_code } from "../../utilis/constants";
import { isValidPhoneNumber } from "react-phone-number-input";
import CustomPhoneInput from "../Agents/InputField";
import { apiUrl } from "../ApiManager/AxiosHeaders";
import {
  CMS_PRIMARY,
  MODULE_PAGE_SHELL_STYLE,
  TASK_PAGE_SHELL_CLASS,
} from "../TaskManagement/workspaceConstants";
import "../../styles/tailwind.css";

const FORM_LABEL = "mb-1 block text-xs font-medium text-gray-700";
const FORM_LABEL_PRIMARY = "mb-1 block text-xs font-semibold text-[#007BFF]";
const FORM_CONTROL =
  "w-full min-w-0 rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-900 focus:border-[#007BFF] focus:outline-none focus:ring-1 focus:ring-[#007BFF] disabled:cursor-not-allowed disabled:bg-gray-50 disabled:opacity-60";
const FORM_TEXTAREA =
  "min-h-[88px] w-full min-w-0 resize-y rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-900 focus:border-[#007BFF] focus:outline-none focus:ring-1 focus:ring-[#007BFF] placeholder:text-gray-400";
const FORM_ERROR = "mt-1 block text-xs font-medium text-red-500";
const FIELD_WRAP = "cms-mig-field min-w-0";
const FORM_ROW_4 = "cms-edu-form-row";
const FORM_ROW_4_SPACED = "cms-edu-form-row cms-mig-form-row--spaced";
const FORM_SECTION = "cms-mig-form-section";

export const withNavigation = (Component) => {
  return (props) => <Component {...props} navigate={useNavigate()} />;
};

class AddClient extends Component {
  constructor(props) {
    super(props);
    this.scrollRef = React.createRef();
    this.state = {
      loading: false,
      nameError: "",
      emailError: "",
      mobileError: "",
      phoneError: "",
      descriptionError: "",
      countryError: "",
      agentError: "",
      subAgentError: "",
      genderError: "",
      externalAgentError: "",
      agentTypeError: "",
      name: "",
      email: "",
      mobile: "",
      country: "",
      superAgent: "",
      subAgent: "",
      agency: [],
      gender: "",
      city: "",
      description: "",
      defaultCountry: "AU",
      externalAgent: "",
      pExternalList: [],
      rExternalList: [],
      selectedProcessingAgent: "",
      selectedReferringAgent: "",
      reference: "",
      referenceBy: "",
      assignedUser: "",
      userList: [],
      assignedUserError: "",
      cityError: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleOptionChange = this.handleOptionChange.bind(this);
  }

  componentDidMount() {
    this.getAgents();
    this.fetchUsersForAssigned();
  }

  fetchUsersForAssigned = async () => {
    try {
      const response = await apiUrl.get("/fetchUsersForAssigned");
      const users = response?.data?.data?.users || [];
      this.setState({ userList: users });
    } catch (error) {
      console.error("Error fetching users:", error);
      // Optional: show user-friendly error or set empty list
      this.setState({ userList: [] });
    }
  };
  async getAgents() {
    const data = "";
    let url = "getAgentsByOffice";
    get_ApiManager(
      data,
      url,
      (res) => {
        console.log("agents by names", res);
        this.setState({
          agency: res.data.data,
        });
      },
      (err) => {
        console.log(err);
      }
    );
  }
  //submit form
  handleSubmit(event) {
    event.preventDefault();
    const fetchUser = JSON.parse(localStorage.getItem("user"));
    const assignedUserId = this.state.assignedUser || fetchUser?.id;

    if (this.handleValidation()) {
      this.setState({ loading: true });
      const data = {
        name: this.state.name,
        mobile: this.state.mobile,
        gender: this.state.gender,
        email: this.state.email,
        city: this.state.city,
        country: this.state.country,
        description: this.state.description,
        agentid: this.state.superAgent,
        subagentid: this.state.subAgent,
        external_agent_exisit: this.state.externalAgent,
        external_processing_agent: this.state.selectedProcessingAgent,
        external_referring_agent: this.state.selectedReferringAgent,
        reference_by: this.state.referenceBy,
        assigned: assignedUserId,
      };
      console.log(data);
      let url = "clients";
      post_ApiManager(
        data,
        url,
        (res) => {
          console.log("client added", res);
          this.setState({ loading: false });
          if (res.data.error) swal(" ", res.data.error, "error");
          else {
            swal("Success!", res.data.message, "success");
            this.props.navigate("/clients/view-clients");
          }
        },
        (err) => {
          console.log(err);
        }
      );
    }
  }
  handleValidation = (e) => {
    var pattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );
    this.setState({
      nameError: null,
      emailError: null,
      mobileError: null,
      agentError: null,
      subAgentError: null,
      genderError: null,
      cityError: null,
      descriptionError: null,
      externalAgentError: "",
      agentTypeError: "",
      assignedUserError: "",
    });
    if (!isValidPhoneNumber(this.state.mobile)) {
      this.setState({ mobileError: "Invalid Mobile Number" });
      return false;
    }
    if (!this.state.name) {
      window.scrollTo(0, this.scrollRef);
      this.setState({ nameError: "Please enter name" });
      return false;
    } else if (this.state.email && !pattern.test(this.state.email)) {
      window.scrollTo(0, this.scrollRef);
      this.setState({ emailError: "Please enter correct email" });
      return false;
    } else if (!this.state.superAgent) {
      window.scrollTo(0, this.scrollRef);
      this.setState({ agentError: "Please select processing branch" });
      return false;
    } else if (!this.state.subAgent) {
      window.scrollTo(0, this.scrollRef);
      this.setState({ subAgentError: "Please select referring branch" });
      return false;
    } else if (!this.state.gender) {
      this.setState({ genderError: "Please select gender" });
      return false;
    } else if (!this.state.country) {
      this.setState({ countryError: "Please select country" });
      return false;
    } else if (!this.state.city) {
      this.setState({ cityError: "Please select city" });
      return false;
    } else if (!this.state.externalAgent) {
      this.setState({
        externalAgentError: "Please select external link option",
      });
      return false;
    } else if (
      this.state.externalAgent === "yes" &&
      !this.state.selectedProcessingAgent &&
      !this.state.selectedReferringAgent
    ) {
      this.setState({ externalAgentError: "Please select external agent" });
      return false;
    } else if (!this.state.description) {
      this.setState({ descriptionError: "Please enter short description" });
      return false;
    } else return true;
  };

  //set input values
  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }
  handleOptionChange(e) {
    this.setState({
      [e.target.name]: e.target.options[e.target.selectedIndex].text,
    });
  }
  // Get all information from apis
  getExternalAgentList = () => {
    let url = "getExternalAgents";
    console.log(url);
    get_ApiManager(
      "",
      url,
      (res) => {
        console.log("agentList", res);
        this.setState({
          rExternalList: res.data.data["referring"],
          pExternalList: res.data.data["processing"],
        });
      },
      (err) => {
        console.log(err);
      }
    );
  };

  render() {
    const sortedAgencies = []
      .concat(this.state.agency)
      .sort((a, b) => (a.agencyname > b.agencyname ? 1 : -1));

    return (
      <>
        <Title back={true} hideTitle flushLeft titleCol="col-12" />
        <div className="tailwind-container">
          <div className={TASK_PAGE_SHELL_CLASS} style={MODULE_PAGE_SHELL_STYLE}>
            <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
              <div className="relative border-b border-gray-100 bg-white px-4 py-3 sm:px-5">
                <div
                  className="absolute inset-x-0 top-0 h-[3px]"
                  style={{ backgroundColor: CMS_PRIMARY }}
                />
                <h2 className="text-sm font-semibold leading-tight text-[#35314d] sm:text-base">
                  Add Client
                </h2>
                <p className="mt-0.5 text-[10px] text-gray-500 sm:text-xs">
                  Complete the details below to create a new client record.
                </p>
              </div>

              <form
                ref={this.scrollRef}
                action=""
                onSubmit={this.handleSubmit}
                className="p-4 sm:p-5"
              >
                <div className={FORM_ROW_4}>
                  <div className={FIELD_WRAP}>
                    <label className={FORM_LABEL} htmlFor="add-client-name">
                      Client name<span className="text-red-500">*</span>
                    </label>
                    <input
                      id="add-client-name"
                      type="text"
                      name="name"
                      onChange={this.handleChange}
                      className={FORM_CONTROL}
                      placeholder="Enter full name"
                    />
                    {this.state.nameError && (
                      <small className={FORM_ERROR}>{this.state.nameError}</small>
                    )}
                  </div>

                  <div className={FIELD_WRAP}>
                    <label className={FORM_LABEL} htmlFor="add-client-email">
                      Client email
                    </label>
                    <input
                      id="add-client-email"
                      type="email"
                      name="email"
                      onChange={this.handleChange}
                      className={FORM_CONTROL}
                      placeholder="Enter email"
                    />
                    {this.state.emailError && (
                      <small className={FORM_ERROR}>{this.state.emailError}</small>
                    )}
                  </div>

                  <div className={FIELD_WRAP}>
                    <label className={FORM_LABEL_PRIMARY} htmlFor="add-client-assigned">
                      Client assigned to
                    </label>
                    <select
                      id="add-client-assigned"
                      value={this.state.assignedUser}
                      className={FORM_CONTROL}
                      onChange={(e) =>
                        this.setState({ assignedUser: e.target.value })
                      }
                    >
                      <option value="">Please select</option>
                      {this.state.userList.length > 0 ? (
                        this.state.userList.map((user) => (
                          <option key={user?.id} value={user?.id}>
                            {user?.name}
                          </option>
                        ))
                      ) : (
                        <option disabled value="">
                          No users available
                        </option>
                      )}
                    </select>
                    {this.state.assignedUserError && (
                      <small className={FORM_ERROR}>
                        {this.state.assignedUserError}
                      </small>
                    )}
                  </div>

                  <div className={FIELD_WRAP}>
                    <CustomPhoneInput
                      variant="tailwind"
                      id="add-client-mobile"
                      label="Mobile"
                      labelClassName={FORM_LABEL}
                      required
                      value={this.state.mobile}
                      onChange={(mobile) => this.setState({ mobile })}
                      error={this.state.mobileError}
                      placeholder="Enter phone number"
                      defaultCountry={this.state.defaultCountry}
                    />
                  </div>
                </div>

                <div className={FORM_ROW_4_SPACED}>
                  <div className={FIELD_WRAP}>
                    <label className={FORM_LABEL} htmlFor="add-client-processing">
                      Processing branch<span className="text-red-500">*</span>
                    </label>
                    <select
                      id="add-client-processing"
                      className={FORM_CONTROL}
                      name="superAgent"
                      value={this.state.superAgent}
                      onChange={this.handleChange}
                    >
                      <option value="">Please select</option>
                      {sortedAgencies.map((value) => (
                        <option key={value.id} value={value.id}>
                          {value.agencyname}
                        </option>
                      ))}
                    </select>
                    {this.state.agentError && (
                      <small className={FORM_ERROR}>{this.state.agentError}</small>
                    )}
                  </div>

                  <div className={FIELD_WRAP}>
                    <label className={FORM_LABEL} htmlFor="add-client-referring">
                      Referring branch<span className="text-red-500">*</span>
                    </label>
                    <select
                      id="add-client-referring"
                      className={FORM_CONTROL}
                      name="subAgent"
                      value={this.state.subAgent}
                      onChange={this.handleChange}
                    >
                      <option value="">Please select</option>
                      {sortedAgencies.map((value) => (
                        <option key={value.id} value={value.id}>
                          {value.agencyname}
                        </option>
                      ))}
                    </select>
                    {this.state.subAgentError && (
                      <small className={FORM_ERROR}>{this.state.subAgentError}</small>
                    )}
                  </div>

                  <div className={FIELD_WRAP}>
                    <label className={FORM_LABEL} htmlFor="add-client-gender">
                      Gender<span className="text-red-500">*</span>
                    </label>
                    <select
                      id="add-client-gender"
                      className={FORM_CONTROL}
                      name="gender"
                      value={this.state.gender}
                      onChange={this.handleChange}
                    >
                      <option value="">Please select</option>
                      <option value="0">Male</option>
                      <option value="1">Female</option>
                      <option value="2">Other</option>
                    </select>
                    {this.state.genderError && (
                      <small className={FORM_ERROR}>{this.state.genderError}</small>
                    )}
                  </div>

                  <div className={FIELD_WRAP}>
                    <label className={FORM_LABEL} htmlFor="add-client-country">
                      Country<span className="text-red-500">*</span>
                    </label>
                    <select
                      id="add-client-country"
                      className={FORM_CONTROL}
                      onChange={this.handleOptionChange}
                      name="country"
                      value={
                        countries_code.find((c) => c.value === this.state.country)
                          ?.country || ""
                      }
                    >
                      <option value="">Please select</option>
                      {countries_code.map((value) => (
                        <option key={value.country} value={value.country}>
                          {value.value}
                        </option>
                      ))}
                    </select>
                    {this.state.countryError && (
                      <small className={FORM_ERROR}>{this.state.countryError}</small>
                    )}
                  </div>
                </div>

                <div className={FORM_ROW_4_SPACED}>
                  <div className={FIELD_WRAP}>
                    <label className={FORM_LABEL} htmlFor="add-client-city">
                      City<span className="text-red-500">*</span>
                    </label>
                    <input
                      id="add-client-city"
                      type="text"
                      name="city"
                      value={this.state.city}
                      onChange={this.handleChange}
                      className={FORM_CONTROL}
                      placeholder="Enter city"
                    />
                    {this.state.cityError && (
                      <small className={FORM_ERROR}>{this.state.cityError}</small>
                    )}
                  </div>
                </div>

                <div className={FORM_SECTION}>
                  <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
                    <span className="text-xs font-medium text-gray-700">
                      Does this client have an external agent?
                      <span className="text-red-500">*</span>
                    </span>
                    <label className="inline-flex cursor-pointer items-center gap-2 text-xs font-medium text-gray-700">
                      <input
                        type="radio"
                        className="h-4 w-4 accent-[#007BFF]"
                        name="external_agent"
                        value="yes"
                        checked={this.state.externalAgent === "yes"}
                        onChange={(e) =>
                          this.setState({ externalAgent: e.target.value }, () => {
                            this.getExternalAgentList();
                          })
                        }
                      />
                      Yes
                    </label>
                    <label className="inline-flex cursor-pointer items-center gap-2 text-xs font-medium text-gray-700">
                      <input
                        type="radio"
                        className="h-4 w-4 accent-[#007BFF]"
                        name="external_agent"
                        value="no"
                        checked={this.state.externalAgent === "no"}
                        onChange={(e) =>
                          this.setState({ externalAgent: e.target.value })
                        }
                      />
                      No
                    </label>
                  </div>
                  {this.state.externalAgentError && (
                    <small className={FORM_ERROR}>{this.state.externalAgentError}</small>
                  )}
                </div>

                {this.state.externalAgent === "yes" && (
                  <div className={FORM_ROW_4_SPACED}>
                    <div className={FIELD_WRAP}>
                      <label className={FORM_LABEL}>External referring agent</label>
                      <select
                        value={this.state.selectedReferringAgent}
                        onChange={(e) =>
                          this.setState({
                            selectedReferringAgent: e.target.value,
                          })
                        }
                        className={FORM_CONTROL}
                        name="external_referring"
                      >
                        <option value="">Please select</option>
                        {[]
                          .concat(this.state.rExternalList)
                          .sort((a, b) =>
                            a.agencyname > b.agencyname ? 1 : -1,
                          )
                          .map((head) => (
                            <option key={head.id} value={head.id}>
                              {head.agencyname}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className={FIELD_WRAP}>
                      <label className={FORM_LABEL}>External processing agent</label>
                      <select
                        value={this.state.selectedProcessingAgent}
                        onChange={(e) =>
                          this.setState({
                            selectedProcessingAgent: e.target.value,
                          })
                        }
                        className={FORM_CONTROL}
                        name="external_processing"
                      >
                        <option value="">Please select</option>
                        {[]
                          .concat(this.state.pExternalList)
                          .sort((a, b) =>
                            a.agencyname > b.agencyname ? 1 : -1,
                          )
                          .map((head) => (
                            <option key={head.id} value={head.id}>
                              {head.agencyname}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                )}

                <div className={FORM_SECTION}>
                  <label className="inline-flex cursor-pointer items-center gap-2 text-xs font-medium text-gray-700">
                    <input
                      type="checkbox"
                      className="h-4 w-4 rounded border-gray-300 accent-[#007BFF]"
                      checked={Boolean(this.state.reference)}
                      onChange={(e) =>
                        this.setState({ reference: e.target.checked })
                      }
                    />
                    Add reference
                  </label>
                  {this.state.reference && (
                    <div className="max-w-md">
                      <input
                        name="referenceBy"
                        type="text"
                        value={this.state.referenceBy}
                        placeholder="Who referred this client?"
                        className={FORM_CONTROL}
                        onChange={this.handleChange}
                      />
                    </div>
                  )}
                </div>

                <div className={FORM_SECTION}>
                  <label className={FORM_LABEL} htmlFor="add-client-description">
                    Description<span className="text-red-500">*</span>
                  </label>
                  <textarea
                    id="add-client-description"
                    className={FORM_TEXTAREA}
                    name="description"
                    value={this.state.description}
                    placeholder="Brief notes about this client or work to be done"
                    onChange={this.handleChange}
                    rows={4}
                  />
                  {this.state.descriptionError && (
                    <small className={FORM_ERROR}>{this.state.descriptionError}</small>
                  )}
                </div>

                <div className={`${FORM_SECTION} cms-mig-form-actions`}>
                  <button
                    type="submit"
                    disabled={this.state.loading}
                    className="inline-flex h-[42px] items-center justify-center rounded-lg px-5 text-sm font-semibold text-white transition hover:brightness-95 disabled:cursor-not-allowed disabled:opacity-60"
                    style={{ backgroundColor: CMS_PRIMARY }}
                  >
                    {this.state.loading ? "Creating…" : "Create client"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default withNavigation(AddClient);
